var autoLoadDuration = 12;
var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
var autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);
window.themeMainLoaded = false;
eventList.forEach(function(event) {
    window.addEventListener(event, triggerScripts, { passive: true })
});

document.addEventListener("click", function(event) {
    if (event.target.closest(".navbar-toggler.toggle-mobile")) {
        document.body.classList.add("navbar-collapse-show", "navbar-open");
        event.target.closest(".navbar-toggler.toggle-mobile").setAttribute("aria-expanded", "true");
    }

    if (event.target.closest(".back-wrapper.menu-close, .menu-overlay")) {
        document.body.classList.remove("navbar-collapse-show", "navbar-open");
        document.querySelectorAll(".navbar-toggler.toggle-mobile").forEach(function(toggle) {
            toggle.setAttribute("aria-expanded", "false");
        });
    }

    var footerToggle = event.target.closest("footer .block-heading.mobile-toggle");
    if (footerToggle && window.innerWidth < 768) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var footerPanel = footerToggle.nextElementSibling;

        if (footerPanel && (footerPanel.classList.contains("footer-menu-link") || footerPanel.classList.contains("custom-content"))) {
            var isOpen = footerToggle.classList.toggle("menu-open");
            footerPanel.style.display = isOpen ? "block" : "none";
        }
    }
}, true);

function triggerScripts() { 
    runScripts();
    clearTimeout(autoLoadTimeout);
    eventList.forEach(function(event) {
         window.removeEventListener(event, triggerScripts, { passive: true });
    });
}
function runScripts() {
    var loadDelayedScripts = function() {
        document.querySelectorAll("script[delay]").forEach(function(scriptTag) {
            if (scriptTag.src) return;
            if (scriptTag.getAttribute("delay").indexOf("main.min.js") !== -1) {
                scriptTag.addEventListener("load", function() {
                    window.themeMainLoaded = true;
                }, { once: true });
            }
            scriptTag.setAttribute("src", scriptTag.getAttribute("delay"));
            scriptTag.removeAttribute("delay");
        });
    };

    if ("requestIdleCallback" in window) {
        requestIdleCallback(loadDelayedScripts, { timeout: 1500 });
    } else {
        setTimeout(loadDelayedScripts, 1);
    }
}
